<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 活动 -->
    <div class="activity">
      <div class="activities-card">
        <div class="activities-card-item" v-for="(item,index) in listData" :key="index" @click="toDetails(item.id)">
          <div class="activities-card-img">
            <img :src="item.image" alt="">
          </div>
          <div class="card-bottom">
            <div class="card-msg">{{ item.title }}</div>
            <div class="textleft">
              <span class="card-time">{{ item.end_time }} 结束</span>
            </div>
            <span class="card-status">{{item.ing_text}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'activity',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        listData: [],
        currentPage:1
      }
    },
    created() {
      this.getData()
    },
    methods: {
      toDetails(id) {
        this.$router.push({
          path: "/activitydetail",
          query: {
            id: id
          }
        })
      },
      getData() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Activity/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "limit": 66,
            "page": this.currentPage
          }
        }).then(res => {
          this.listData = res.data.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped>
  .activity {
    padding-top: 60px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .activities-card {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }

  .activities-card-item {
    width: 560px;
    height: 344px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgb(0 0 0 / 4%);
    border-radius: 10px;
    margin: 0 20px 40px 0;
    cursor: pointer;
  }

  .card-bottom {
    padding: 16px;
    position: relative;
  }

  .card-msg {
    max-width: 460px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 24px;
    text-align: left;
  }

  .textleft {
    text-align: left;
  }

  .card-status {
    background-color: #ffb900;
    width: 102px;
    height: 40px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #18252c;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .card-time {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #a3a8ab;
  }

  .card-number {
    margin-left: 24px;
  }

  .activities-card-img {
    width: 100%;
    height: 264px;
    overflow:hidden;
    border-radius: 10px 10px 0 0;
  }

  .activities-card-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #a3a8ab;
  }
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue